export const mutationUpdateAfter = (state, data, dataName) => {
  if (Array.isArray(state[dataName])) {
    if (data.length === 0) return
    const stateMap = new Map(state[dataName].map((v, i) => [v.id, i]))
    data.forEach(datum => {
      const index = stateMap.get(datum.id)
      if (index >= 0) {
        if (state[dataName][index].updatedAt <= datum.updatedAt) {
          state[dataName].splice(index, 1, datum)
        }
      } else {
        state[dataName].push(datum)
        stateMap.set(datum.id, state[dataName].length - 1)
      }
    })
  } else {
    if (state[dataName].updatedAt <= data.updatedAt) {
      state[dataName] = data
    }
  }
}
